const DEFAULT_PUBLIC_METRICS_URL =
  "https://us-central1-whatsappconversion.cloudfunctions.net/publicLandingMetrics";
const PUBLIC_METRICS_CACHE_KEY = "echomsg_public_metrics_total";

const normalizeUrl = (value) => (value || "").trim().replace(/\/+$/, "");
const normalizeMetricValue = (value) => {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : null;
};

export const PUBLIC_LANDING_METRICS_URL = normalizeUrl(
  process.env.REACT_APP_PUBLIC_METRICS_URL || DEFAULT_PUBLIC_METRICS_URL
);

export const readCachedPublicTranscriptionCount = () => {
  if (typeof window === "undefined") {
    return null;
  }

  const cachedValue = window.localStorage.getItem(PUBLIC_METRICS_CACHE_KEY);
  return normalizeMetricValue(cachedValue);
};

export const cachePublicTranscriptionCount = (value) => {
  if (typeof window === "undefined") {
    return;
  }

  const normalizedValue = normalizeMetricValue(value);
  if (normalizedValue === null) {
    return;
  }

  window.localStorage.setItem(
    PUBLIC_METRICS_CACHE_KEY,
    String(normalizedValue)
  );
};

export const fetchPublicTranscriptionCount = async () => {
  const requestUrl = new URL(PUBLIC_LANDING_METRICS_URL);
  requestUrl.searchParams.set("_ts", String(Date.now()));

  const response = await fetch(requestUrl.toString(), {
    cache: "no-store",
    headers: {
      Accept: "application/json",
    },
    method: "GET",
  });

  if (!response.ok) {
    throw new Error(`Metrics request failed with ${response.status}`);
  }

  const payload = await response.json();
  const totalTranscriptions = normalizeMetricValue(
    payload?.totalMessagesConverted ?? payload?.totalTranscriptions
  );

  if (totalTranscriptions === null) {
    throw new Error("Metrics response did not include a valid transcription count");
  }

  return totalTranscriptions;
};
